

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <producto_usuario></producto_usuario>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import producto_usuario from '@/components/tienda/producto/usuario/Producto.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    producto_usuario
    
  },

  methods: {

}

}
    

</script>


